/* import __COLOCATED_TEMPLATE__ from './table-of-contents.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();